import React, { useContext, useEffect, useReducer, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DatePicker from "react-date-picker";
import { useMediaQuery } from "react-responsive";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import useAxios from "../hooks/useAxios";
import CartScreenTouch from "../screens/CartScreenTouch";
import { Store } from "../Store";
import {
  getError,
  getTableType,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import FiliskaPagination from "./FiliskaPagination";
import ProductTable from "./ProductTable";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCHCART_REQUEST":
      return { ...state, loadingFetchCart: true, errorFetchCart: "" };
    case "FETCHCART_SUCCESS":
      return {
        ...state,
        errorFetchCart: "",
        loadingFetchCart: false,
      };
    case "FETCHCART_FAIL":
      return {
        ...state,
        loadingFetchCart: false,
        errorFetchCart: action.payload,
      };
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const OrderFilter = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [filters, setFilters] = useState({
    user: "",
    businessOwner: "",
    isPaid: "",
    isDelivered: "",
    totalPriceGte: "",
    totalPriceLte: "",
    product: "",
    tableNum: "",
    paymentMethod: "",
    description: "",
    orderItemsName: "",
    orderItemsProduct: "",
    orderItemsFeatureId: "",
  });

  const [{ loadingFetchCart, errorFetchCart, loading }, dispatch] = useReducer(
    reducer,
    {
      loadingFetchCart: false,
      errorFetchCart: "",
      loading: false,
    }
  );

  const axios = useAxios();

  const [orders, setOrders] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [totalPrice, setTotalPrice] = useState();
  const [cart, setCart] = useState({ tableNum: 0 });
  const [showSelectProduct, setShowSelectProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [users, setUsers] = useState([]);
  const [showSelectUser, setShowSelectUser] = useState();
  const [selectedUser, setSelectedUser] = useState();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [pages, setPages] = useState(1);
  const [page, setPage] = useState(1);

  const { state } = useContext(Store);

  const { tableTypesAll: tableTypes = [] } = state;

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch({ type: "FETCH_REQUEST" });
        const { data } = await axios.get(`/api/busers/all`);
        dispatch({ type: "FETCH_SUCCESS" });
        setUsers(data);
      } catch (err) {
        dispatch({
          type: "FETCH_FAIL",
          payload: getError(err),
        });
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const handleFilter = async (filters, filterPage) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const response = await axios.get(
        `/api/orders/filter?page=${filterPage || page}&pageSize=10`,
        {
          params: filters,
        }
      );
      setOrders(response.data.orders);
      setPages(response.data.pages);
      setTotalCount(response.data.totalCount);
      setTotalPrice(response.data.totalPrice);
      setPage(filterPage || page);
      dispatch({ type: "FETCH_SUCCESS" });
    } catch (error) {
      dispatch({ type: "FETCH_FAIL" });
      console.error("Error fetching orders", error);
    }
  };

  useEffect(() => {
    handleFilter(filters);
  }, [page]);

  const [showCartScreenTouchModal, setShowCartScreenTouchModal] =
    useState(false);

  const selectProductHandler = (p, feature) => {
    setSelectedProduct(p);
    setFilters({
      ...filters,
      orderItemsProduct: p._id,
    });
    setShowSelectProduct(false);
  };

  const fetchCartHandler = async (lineNum) => {
    try {
      dispatch({ type: "FETCHCART_REQUEST" });
      const { data } = await axios.get(
        `/api/orders/lineNum/${lineNum ? lineNum : "0"}`
      );

      dispatch({ type: "FETCHCART_SUCCESS" });

      setCart(data);
    } catch (error) {
      dispatch({ type: "FETCHCART_FAIL" });
    }
  };

  const handleClear = async () => {
    const clearedFilters = {
      lineNum: "",
      user: "",
      businessOwner: "",
      isPaid: "",
      isDelivered: "",
      totalPriceGte: "",
      totalPriceLte: "",
      product: "",
      tableNum: "",
      paymentMethod: "",
      description: "",
      orderItemsName: "",
      orderItemsProduct: "",
      orderItemsFeatureId: "",
    };
    setFilters(clearedFilters);
    setSelectedProduct({ name: "" });
    setSelectedUser({ name: "" });
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    handleFilter(clearedFilters, 1);
  };

  return (
    <div>
      {!isTabletOrMobile && (
        <>
          <h1 className="my-3 text-muted">Siparişlerde Ara</h1>
          <hr className="hr"></hr>
        </>
      )}
      <form className="row g-3">
        <div className="col-md-6">
          <label htmlFor="user" className="form-label">
            Adisyon Sıra No
          </label>

          <div className="input-group mb-2">
            <input
              type="number"
              className="form-control"
              id="lineNum"
              name="lineNum"
              value={filters.lineNum}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-3">
          <label htmlFor="totalPriceGte" className="form-label">
            Başlama Tarihi
          </label>
          <div>
            <DatePicker
              value={startDate}
              locale="tr-TR"
              closeCalendar={false}
              onChange={(d) => {
                setStartDate(d);
                setFilters({ ...filters, startDate: new Date(d) });
              }}
            ></DatePicker>
          </div>
        </div>

        <div className="col-md-3">
          <label htmlFor="totalPriceLte" className="form-label">
            Bitiş Tarihi
          </label>
          <div>
            <DatePicker
              value={endDate}
              locale="tr-TR"
              closeCalendar={false}
              onChange={(d) => {
                setEndDate(d);
                setFilters({ ...filters, endDate: new Date(d) });
              }}
            ></DatePicker>
          </div>
        </div>
        <div className="col-md-6">
          <label htmlFor="user" className="form-label">
            Kullanıcı Seç
          </label>

          <div className="input-group mb-2">
            <input
              disabled={true}
              type="text"
              className="form-control"
              id="user"
              name="user"
              value={selectedUser?.name}
            />

            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => setShowSelectUser(true)}
              >
                <i className="fas fa-search"></i> Seç
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <label htmlFor="totalPriceGte" className="form-label">
            Tutar Alt Sınır
          </label>
          <input
            type="number"
            className="form-control"
            id="totalPriceGte"
            name="totalPriceGte"
            value={filters.totalPriceGte}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-3">
          <label htmlFor="totalPriceLte" className="form-label">
            Tutar Üst Sınır
          </label>
          <input
            type="number"
            className="form-control"
            id="totalPriceLte"
            name="totalPriceLte"
            value={filters.totalPriceLte}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="tableNum" className="form-label">
            Masa Numarası
          </label>
          <input
            type="number"
            className="form-control"
            id="tableNum"
            name="tableNum"
            value={filters.tableNum}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="description" className="form-label">
            Müşteri Adı
          </label>
          <input
            type="text"
            className="form-control"
            id="description"
            name="description"
            value={filters.description}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="orderItemsName" className="form-label">
            Ürün Adı
          </label>
          <input
            type="text"
            className="form-control"
            id="orderItemsName"
            name="orderItemsName"
            value={filters.orderItemsName}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="orderItemsProduct" className="form-label">
            Ürün Seç
          </label>
          <div className="input-group mb-2">
            <input
              disabled={true}
              type="text"
              className="form-control"
              id="orderItemsProduct"
              name="orderItemsProduct"
              value={selectedProduct?.name}
            />

            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => setShowSelectProduct(true)}
              >
                <i className="fas fa-search"></i> Seç
              </button>
            </div>
          </div>
        </div>
        <div className="col-12">
          <button
            type="button"
            className="btn btn-primary me-2"
            onClick={() => handleFilter(filters, 1)}
            disabled={loading}
          >
            <i className="fa fa-search"></i>
            {loading ? " Arıyor..." : " Ara"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClear}
          >
            <i className="fa fa-times"></i> Temizle
          </button>
        </div>
      </form>
      <div className="mt-5">
        <div className="siparisler-filter-table-header">
          <h3>Siparişler </h3>
          <h6>({totalCount ? totalCount + " sonuç" : ""})</h6>
        </div>
        {loading ? (
          <LoadingBox>Siparişler Yükleniyor!</LoadingBox>
        ) : orders.length > 0 ? (
          <>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th scope="col">Sıra No</th>

                  <th scope="col">Tutar</th>

                  <th scope="col">Masa No</th>

                  <th scope="col">Açıklama/Ad</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order._id}>
                    <td>
                      {new Date(order.createdAt)
                        .toLocaleString("tr-TR")
                        .substring(0, 16)}
                    </td>
                    <td>
                      <div
                        className="text-primary linenNumOrderList"
                        onClick={() => {
                          setShowCartScreenTouchModal(true);
                          fetchCartHandler(order.lineNum);
                        }}
                      >
                        {order.lineNum}
                      </div>
                    </td>

                    <td>
                      {turkishCurrencyFormatterNoPrecision(order.totalPrice)}
                    </td>

                    <td>
                      {order.tableNum}{" "}
                      {getTableType(tableTypes, order.tableType)
                        ? `(${getTableType(tableTypes, order.tableType).name})`
                        : ""}
                    </td>

                    <td>{order.description}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th></th>
                  <th>{totalCount} Adet</th>
                  <th>{turkishCurrencyFormatterNoPrecision(totalPrice)}</th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
            <div>
              <FiliskaPagination
                leftRightSize={1}
                page={page}
                pages={pages}
                onFirst={() => setPage(1)}
                onLast={() => setPage(pages)}
                onNext={() => {
                  if (page < pages) {
                    setPage(page + 1);
                  }
                }}
                onPrev={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}
                onItemNext={(p) => setPage(p)}
                onItemPrev={(p) => setPage(p)}
              ></FiliskaPagination>
            </div>
          </>
        ) : (
          <p>Sipariş bulunamadı!</p>
        )}
      </div>

      {showCartScreenTouchModal && (
        <Modal
          show={showCartScreenTouchModal}
          onHide={() => setShowCartScreenTouchModal(false)}
        >
          <Modal.Body>
            {loadingFetchCart ? (
              <LoadingBox />
            ) : errorFetchCart ? (
              <MessageBox>{getError(errorFetchCart)}</MessageBox>
            ) : (
              <CartScreenTouch
                tableTemp={cart.tableNum}
                isCustomerOrder={false}
                height="100%"
                readOnlyCart={cart}
                historic={true}
                ozetle={true}
              ></CartScreenTouch>
            )}
          </Modal.Body>
        </Modal>
      )}

      <Modal
        show={showSelectProduct}
        onHide={() => setShowSelectProduct(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="text-secondary">{"Ürün Seç"}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProductTable
            type={"menu"}
            productAddHandler={selectProductHandler}
          ></ProductTable>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowSelectProduct(false);
            }}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSelectUser} onHide={() => setShowSelectUser(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="text-secondary">{"Kullanıcı Seç"}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Ad</th>
                <th>Yönetici</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr
                  key={u._id}
                  onClick={() => {
                    setSelectedUser(u);
                    setFilters({
                      ...filters,
                      user: u._id,
                    });
                    setShowSelectUser(false);
                  }}
                >
                  <td>{u.name}</td>
                  <td>
                    {u.role === "business_admin" || u.role === "business_owner"
                      ? "Evet"
                      : "Hayır"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowSelectUser(false);
            }}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderFilter;
